<template>
  <div id="app">
    <router-view />
    <UpdateBanner :show="showUpdateBanner" @dismiss="showUpdateBanner = false" />
  </div>
</template>

<script>
import UpdateBanner from '@/components/UpdateBanner'

export default {
  name: 'App',
  components: {
    UpdateBanner
  },
  data () {
    return {
      showUpdateBanner: false,
      currentVersion: process.env.VUE_APP_BUILD_VERSION || null,
      versionCheckInterval: null
    }
  },
  async mounted () {
    await this.checkVersion()
    // Check every 1 minute
    this.versionCheckInterval = setInterval(() => {
      this.checkVersion()
    }, 60 * 1000)
  },
  beforeDestroy () {
    if (this.versionCheckInterval) {
      clearInterval(this.versionCheckInterval)
    }
  },
  methods: {
    async checkVersion () {
      try {
        const response = await fetch('/version.json?t=' + Date.now(), {
          cache: 'no-store'
        })
        const data = await response.json()
        if (this.currentVersion && data.version !== this.currentVersion) {
          this.showUpdateBanner = true
        }
      } catch (e) {
        // Ignore errors
      }
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler (to, from) {
        document.title = 'Copenhagen Luggage service'
      }
    },
    '$route.query': {
      handler (query) {
        if (!document.cookie.includes('ref=') && query.clsref) {
          const expires = (new Date(Date.now() + 86400 * 21000)).toUTCString() // 21 day
          document.cookie = `ref=${query.clsref}; expires=${expires}; path=/;`
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss">
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  #app {
    position: relative;
  }

  select, textarea, input[type="text"], input[type="password"], input[type="datetime"], input[type="datetime-local"], input[type="date"], input[type="month"], input[type="time"], input[type="week"], input[type="number"], input[type="email"], input[type="url"], input[type="search"], input[type="tel"], input[type="color"] { font-size: 16px !important; background-color: white; }
</style>
